import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { Button, Row, Col } from 'react-bootstrap';
import { getCookieValue } from '../../components/common/access-cookie';
import {
    doLogin,
    forwardForgotPwd,
    LOGIN_FAIL,
    resendCode,
    VERIFY_EMAIL,
    VERIFY_EMAIL_LOADING, VERIFY_EMAIL_SEND_CODE_FAIL, VERIFY_EMAIL_SEND_CODE_SUCCESS
} from '../../actions/login/index';
import { commonRenderInput } from '../../components/common/access-form';
import { verifyForm } from '../../components/common/access-form-validation';
import { doActivePage } from '../../actions/menu/index';
import {openModalAlert, openModalTip} from "../../actions";


class LoginForm extends Component {

    constructor(props) {
        super(props);
        let remember = props.remeberAccount ? true : false;

        this.state = {
            rememberAccount: remember,
            pwdDisplay: false,
            notificationContent: undefined
        }
    };

    loginSubmit = (values) => {
        const { doLogin, inputLoginEmail, inputLoginPwd } = this.props;
        const { rememberAccount } = this.state;

        if (inputLoginEmail && inputLoginPwd) {
            doLogin(inputLoginEmail, inputLoginPwd);
            if (rememberAccount) {
                document.cookie = "account=" + inputLoginEmail;
            } else {
                document.cookie = "account="; // remove cookie
            }
        }
    }

    submitToLoginWithCode = (values) => {
        const { doLogin, username, password, verificationCode } = this.props;
        const { rememberAccount } = this.state;

        if (username && password && verificationCode) {
            doLogin(username, password, verificationCode, VERIFY_EMAIL_LOADING);
            if (rememberAccount) {
                document.cookie = "account=" + username;
            } else {
                document.cookie = "account="; // remove cookie
            }
        }
    }

    async resendCode() {
        const { resendCode, username, password } = this.props;
        resendCode(username, password)
    }

    toggleRememberMe = (e) => {
        // get checked element
        let targetEl = e.target;
        if (targetEl.className === 'area-remeber-me-check') {
            targetEl = e.target.children[0];
        }

        let rememberAccount;
        if (targetEl.className === 'icon-uncheck') {
            targetEl.className = 'icon-check';
            rememberAccount = true;
        } else {
            targetEl.className = 'icon-uncheck';
            rememberAccount = false;
        }

        this.setState({
            rememberAccount: rememberAccount
        });
    }

    togglePwdDisplay = () => {
        const { pwdDisplay } = this.state;
        this.setState({
            pwdDisplay: !pwdDisplay
        })
    }

    forgotPassword = (e) => {
        const { doActivePage /*, openModal */ } = this.props;
        // openModal("applyAccount", 'add', null, null);
        doActivePage('ForgotPassword');
        // this.setState({displayPage: 'create'});
    }

    signUp = (e) => {
        const { doActivePage } = this.props;
        doActivePage('Signup');
    }

    render() {
        const { handleSubmit, verifyFormPass, status, errMsg/*, forwardForgotPwd */ } = this.props;
        const { pwdDisplay } = this.state;
        let classAreaFormGroup = 'area-form-group';

        // let classCheck = 'icon-uncheck'

        // if (remeberAccount) {
        //     classCheck = 'icon-check';
        // }

        let pwdType = 'password';
        let classPwd = 'icon-btn-password-hide-n'
        if (pwdDisplay) {
            pwdType = 'text';
            classPwd = 'icon-btn-password-show-n';
        }

        let alertMsgContent = (
            <div className='area-alert-msg'></div>
        );

        if (errMsg && ([LOGIN_FAIL, VERIFY_EMAIL].includes(status))) {
            alertMsgContent = (
                <div className='area-alert-msg'><label>{errMsg}</label></div>
            );
            classAreaFormGroup += ' fail-msg';
        }

        if ([VERIFY_EMAIL, VERIFY_EMAIL_LOADING, VERIFY_EMAIL_SEND_CODE_FAIL, VERIFY_EMAIL_SEND_CODE_SUCCESS].includes(status)) {
            return (
                <div className='area-login-form form-custom'>
                    <form onSubmit={handleSubmit(this.submitToLoginWithCode)} className='login-form'>
                        <br />
                        <div className='notification-content'>
                            {this.state.notificationContent}
                        </div>
                        <div className={classAreaFormGroup}>
                            <Row>
                                <Col sm={12}>
                                    <div className='area-form-label'>
                                        <label className='need-star-label'></label><label>Verification code</label>
                                    </div>
                                </Col>
                                <Col sm={12}>
                                    <div className='area-form-field'>
                                        <Field name="inputVerificationCode" type="text" component={commonRenderInput}
                                               placeholder="Please input the verification code"/>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {alertMsgContent}
                        <div className="area-sign-up">
                        <span className='href-class' onClick={() => this.resendCode()}>
                            Resend code
                        </span>
                        </div>
                        <div className='area-btn-login'>
                            <Button type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>
                                <span>Continue</span>
                            </Button>
                        </div>
                    </form>
                </div>
            );
        }

        return (
            <div className='area-login-form form-custom'>
                <form id="login-form" onSubmit={handleSubmit(this.loginSubmit)} className='login-form'>
                    <div className={classAreaFormGroup}>
                        <Row>
                            <Col sm={12}>
                                <div className='area-form-label'>
                                    <label className='need-star-label'></label><label>Account </label>
                                </div>
                            </Col>
                            <Col sm={12}>
                                <div className='area-form-field'>
                                    <Field id="login-form-account" name="inputLoginEmail" type="text" component={commonRenderInput}
                                           placeholder="Please input your account"/>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {alertMsgContent}
                    <div className={classAreaFormGroup}>
                        <Row>
                            <Col sm={12}>
                                <div className='area-form-label'>
                                    <label className='need-star-label'></label><label>Password </label>
                                </div>
                            </Col>
                            <Col sm={11}>
                                <div className='area-form-field'>
                                    <Field id="login-form-password" name="inputLoginPwd" type={pwdType} component={commonRenderInput}
                                           placeholder="Please input password"/>
                                </div>
                            </Col>
                            <Col sm={1}>
                                <div className='area-form-icon' style={{paddingLeft: '10px'}}><span id="login-form-toggle-pwd" className={classPwd}
                                                                                                    onClick={this.togglePwdDisplay}></span>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="area-forgot-pwd" >
                        <span id="login-form-forgotPwd" className='href-class' onClick={this.forgotPassword}>
                            Forgot password?
                        </span>
                    </div>
                    {/* <div className="area-forgot-pwd" >
                        <span className='href-class' onClick={forwardForgotPwd}>
                            Forgot password?
                        </span>
                    </div>                     */}
                    <div className="area-sign-up">
                        <span id="login-form-create-account" className='href-class' onClick={this.signUp}>
                            Create a new account
                        </span>
                    </div>
                    <div className='area-btn-login'>
                        <Button id="login-form-button-continue" type="submit" variant="primary" size="lg" disabled={!verifyFormPass} block>
                            <span>Continue</span>
                        </Button>
                    </div>
                </form>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { status, errMsg, openModalAlert, openModalTip, notificationContent } = this.props;
        if (!this.state.notificationContent && (status === VERIFY_EMAIL && notificationContent)) {
            this.setState({notificationContent: notificationContent})
        }
        if (prevProps.status !== status || prevProps.errMsg !== errMsg) {
            if (status === VERIFY_EMAIL_SEND_CODE_FAIL) {
                openModalAlert(errMsg)
            } else if (status === VERIFY_EMAIL_SEND_CODE_SUCCESS) {
                openModalTip("Another code has been sent to your email.");
            }
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    let verifyFormPass = verifyForm(state.form['LoginForm']);
    const remeberAccount = getCookieValue('account');
    const loginForm = formValueSelector('LoginForm');
    const inputLoginEmail = loginForm(state, 'inputLoginEmail');
    const inputLoginPwd = loginForm(state, 'inputLoginPwd');
    const verificationCode = loginForm(state, 'inputVerificationCode');

    let ret = {
        status: state.loginReducers.status,
        verifyFormPass: verifyFormPass,
        notificationContent: state.loginReducers.notificationContent,
        errMsg: state.loginReducers.errMsg,
        username: state.loginReducers.username,
        password: state.loginReducers.password,
        verificationCode: verificationCode,
        remeberAccount: remeberAccount,
        inputLoginEmail: inputLoginEmail,
        inputLoginPwd: inputLoginPwd
    }

    if (remeberAccount) {
        let initialValues = {};
        initialValues['inputLoginEmail'] = remeberAccount;
        ret['initialValues'] = initialValues;
    }

    return ret;
};

LoginForm = reduxForm({
    form: 'LoginForm',  // a unique identifier for this form
})(LoginForm);

export default connect(
    mapStateToProps,
    {forwardForgotPwd, doLogin, resendCode, doActivePage, openModalAlert, openModalTip }
)(LoginForm);